/**
 *  Switch
 *  Author: Teemo
 *  CreatedAt: 2021-03-03
 */

import React from 'react';
import { Switch as SwitchAntd } from 'antd';
const Switch = (props) => {
  const { defaultChecked, onChange, checked, disabled } = props;
  return (
    <SwitchAntd
      defaultChecked={defaultChecked}
      checked={checked}
      disabled={disabled}
      onChange={onChange}
    />
  );
};
export default Switch;
